export var DataAnalytics;
(function (DataAnalytics) {
    DataAnalytics["clickTrackingEvent"] = "clicktrackingevent";
})(DataAnalytics || (DataAnalytics = {}));
export var DataObject;
(function (DataObject) {
    DataObject["button"] = "button";
    DataObject["collapse"] = "collapse";
    DataObject["donut"] = "donut";
    DataObject["dropdownExpand"] = "drop-down-expand";
    DataObject["dropdownCollapse"] = "drop-down-collapse";
    DataObject["expand"] = "expand";
    DataObject["highToLow"] = "high to low";
    DataObject["lowToHigh"] = "low to high";
    DataObject["link"] = "link";
    DataObject["toggleOn"] = "toggle on";
    DataObject["toggleOff"] = "toggle off";
})(DataObject || (DataObject = {}));
//# sourceMappingURL=common.js.map